import Select from 'react-select';

Select.defaultProps = {
  ...Select.defaultProps,
  menuPortalTarget: null,
  menuPosition: 'absolute',
  menuPlacement: 'bottom',
  menuShouldScrollIntoView: true,
  menuShouldBlockScroll: false,
  closeMenuOnScroll: true,
};
